import "antd/dist/antd.css";
import {
  Box,
  Input,
  Text,
  Flex,
  Spacer,
  Button,
  SimpleGrid,
  Textarea,
  FormControl,
  FormErrorMessage,
} from "@chakra-ui/react";
import React, { useState, useEffect } from "react";
import Parse from "parse";
import "react-datepicker/dist/react-datepicker.css";
import ShowOffer from "./ShowOffer.jsx";
import { useParams, useNavigate } from "react-router-dom";
import Navbar from "./NavBar/NavBar";
import SearchLocationInput from "./SearchLocationInput.jsx";
import UploadImage from "./UploadImage.jsx";
import moment from "moment-with-locales-es6";
import { Grid, Select } from "@mantine/core";

export const EditerOffres = ({ title }) => {
  const navigate = useNavigate();

  const contrat_type = [
    "CDI",
    "CDD",
    "Intérim",
    "Alternance",
    "Contrat Pro",
    "Auto-entrepreneur",
    "POEIC",
    "VIE,VIA",
    "CUI",
    "Stage",
  ];
  const work_domaine = [
    "Achat",
    "Administratif",
    "Agroalimentaire",
    "Artisanat",
    "Banque/Assurance",
    "BTP/Matériaux de construction",
    "Chimie/Parachimie",
    "Coiffure",
    "Communication",
    "Commerce",
    "Culture",
    "Sports/Loisirs",
    "Edition/Communication/Multimédia",
    "Enseignement/Formation",
    "Entretien/Maintenance",
    "Électronique/Électricité",
    "Etudes et conseil/ Audit/Consulting",
    "Hôtellerie/Restauration/Tourisme",
    "Immobilier",
    "Industrie pharmaceutique",
    "Ingénierie",
    "Informatique/Télécoms",
    "Juridique",
    "Marketing",
    "Métallurgie/Travail du métal",
    "Qualité/Sécurité/Environnement",
    "Ressources humaines",
    "Santé/Action sociale",
    "Services aux entreprises",
    "Service aux particuliers/Collectivités",
    "Mode",
    "Transports/Logistique",
  ];

  const { id } = useParams();

  const show = true;

  const [nomOffre, setNomOffre] = useState("");
  const [contrat, setContrat] = useState("");
  const [secteur, setSecteur] = useState("");
  const [nomEntreprise, setNomEntreprise] = useState("");
  const [adresseEntreprise, setAdresseEntreprise] = useState("");
  const [dateDebut, setDateDebut] = useState("");
  const [duration, setDuration] = useState("");
  const [resume, setResume] = useState("");
  const [missions, setMissions] = useState("");
  const [showMissionsLabel, setShowMissionsLabel] = useState(false);
  const [imageFile, setImageFile] = useState("");
  const [adress, setAddress] = useState("");
  const [url, setUrl] = useState("");
  const [coords, setCoords] = useState({ lat: null, lng: null });
  const [experience, setExperience] = useState("");

  const [eExperience, setEexperience] = useState(false);
  const [eAdress, setEAddress] = useState("");
  const [eNomOffre, setENomOffre] = useState(false);
  const [eContrat, setEContrat] = useState(false);
  const [eSecteur, setESecteur] = useState(false);
  const [eNomEntreprise, setENomEntreprise] = useState(false);
  const [eAdresseEntreprise, setEAdresseEntreprise] = useState(false);
  const [eDateDebut, setEDateDebut] = useState(false);
  const [eDuration, setEDuration] = useState(false);
  const [eResume, setEResume] = useState(false);
  const [eMissions, setEMissions] = useState(false);

  const [startDate, setStartDate] = useState(new Date());

  const getImageFile = (image) => {
    setImageFile(image);
    setUrl("");
  };

  const getCoords = (latlng) => {
    setCoords(latlng);
  };

  const getAddress = (adr) => {
    setAddress(adr);
    setAdresseEntreprise(adr.formatted_address);
  };

  async function fetchOffer() {
    const Offer = Parse.Object.extend("Annonce");
    const query = new Parse.Query(Offer);
    query.equalTo("type", "job");
    query.equalTo("objectId", id);
    const offer = await query.first();

    return offer;
  }

  const [offre, setOffre] = useState();

  useEffect(() => {
    let isMounted = true;
    fetchOffer().then((offer) => {
      if (isMounted) {
        setOffre(offer);
        setNomOffre(offer.get("titre"));
        setContrat(offer.get("typeContrat"));
        setSecteur(offer.get("secteur"));
        if (offer.get("logoEnterprise")) {
          setUrl(offer.get("logoEnterprise").url());
        }
        setExperience(offer.get("experience"));

        setNomEntreprise(offer.get("entreprise"));
        setAdresseEntreprise(offer.get("adresse"));
        setDateDebut(offer.get("dateDebut").toString());
        setDuration(offer.get("duration"));
        setShowMissionsLabel(offer.get("missions") ? true : false);
        setResume(offer.get("resume"));
        setMissions(offer.get("missions"));
      }
    });
    return () => {
      isMounted = false;
    };
  }, []);

  useEffect(() => {
    if (!offre) return;
  }, [offre]);

  useEffect(() => {
    if (missions) {
      if (missions.length > 0) {
        setShowMissionsLabel(true);
      } else {
        setShowMissionsLabel(false);
      }
    }
  }, [missions, eNomOffre]);

  const handleClosure = (e) => {
    offre.set("visible", false);
    offre.save().then(
      (offre) => {
        navigate("/Offers");
      },
      (error) => {
        alert("Failed to create new Offer, with error code: " + error.message);
      }
    );
  };

  const handleSubmit = (e) => {
    let canSubmit = true;
    setENomOffre(false);
    setEContrat(false);
    setESecteur(false);
    setENomEntreprise(false);
    setEAdresseEntreprise(false);
    setEDateDebut(false);
    setEDuration(false);
    setEResume(false);
    setEMissions(false);
    setEexperience(false);

    if (nomOffre) {
      if (nomOffre.length === 0) {
        setENomOffre(true);
        canSubmit = false;
      }
    } else {
      setENomOffre(true);
      canSubmit = false;
    }
    if (contrat) {
      if (contrat.length === 0) {
        setESecteur(true);
        canSubmit = false;
      }
    } else {
      setESecteur(true);
      canSubmit = false;
    }
    if (secteur) {
      if (secteur.length === 0) {
        setESecteur(true);
        canSubmit = false;
      }
    } else {
      setESecteur(true);
      canSubmit = false;
    }
    if (nomEntreprise) {
      if (nomEntreprise.length === 0) {
        setENomEntreprise(true);
        canSubmit = false;
      }
    } else {
      setENomEntreprise(true);
      canSubmit = false;
    }
    if (experience) {
      if (experience.length === 0) {
        setEexperience(true);
        canSubmit = false;
      }
    } else {
      setEexperience(true);
      canSubmit = false;
    }
    if (adresseEntreprise) {
      if (adresseEntreprise.length === 0) {
        setEAdresseEntreprise(true);
        canSubmit = false;
      }
    } else {
      setEAdresseEntreprise(true);
      canSubmit = false;
    }
    if (dateDebut) {
      if (dateDebut.length === 0) {
        setEDateDebut(true);
        canSubmit = false;
      }
    } else {
      setEDateDebut(true);
      canSubmit = false;
    }
    if (duration) {
      if (duration.length === 0) {
        setEDuration(true);
        canSubmit = false;
      }
    } else {
      setEDuration(true);
      canSubmit = false;
    }
    if (resume) {
      if (resume.length === 0) {
        setEResume(true);
        canSubmit = false;
      }
    } else {
      setEResume(true);
      canSubmit = false;
    }
    if (missions) {
      if (missions.length === 0) {
        setEMissions(true);
        canSubmit = false;
      }
    } else {
      setEMissions(true);
      canSubmit = false;
    }

    if (canSubmit) {
      if (startDate.toString() === dateDebut) {
        offre.set("dateDebut", startDate);
      }
      if (imageFile) {
        const iconImageFile = new Parse.File("offer", imageFile);
        offre.set("logoEnterprise", iconImageFile);
      }
      offre.set("resume", resume);
      offre.set("missions", missions);
      offre.set("duration", duration);
      offre.set("titre", nomOffre);
      offre.set("typeContrat", contrat);
      offre.set("entreprise", nomEntreprise);
      offre.set("experience", experience);
      offre.set("secteur", secteur);
      offre.set("experience", experience);
      offre.set("type", "job");
      offre.set("listUser", []);
      if (adress) {
        const point = new Parse.GeoPoint(coords.lat, coords.lng);
        offre.set("position", point);
        offre.set("adresse", adress.formatted_address);
        offre.set("ville", adress.address_components[2].long_name);
        offre.set("codePostal", adress.address_components[6].long_name);
      }
      offre.save().then(
        (offre) => {
          navigate("/Offers");
        },
        (error) => {
          alert(
            "Failed to create new Offer, with error code: " + error.message
          );
        }
      );
    }
  };

  return (
    <Box display="flex" w={"100%"}>
      <Navbar />
      <Box
        mt={["20px", "20px", "0px", "0px"]}
        w={"100%"}
        mb={["120px", "120px", "0px", "0px"]}
      >
        <Text
          ml={["20px", "20px", "40px", "40px"]}
          fontFamily={"Sofia pro"}
          fontSize={"5xl"}
          fontWeight={"bolder"}
        >
          Modifier l’offre
        </Text>
        <Box
          p="0px"
          mx={["10px", "10px", "50px", "50px"]}
          mt={["20px", "20px", "0px", "0px"]}
          w={["100%", "100%", "calc(100% - 100px) ", "calc(100% - 100px)"]}
          h={["100%", "100%", "calc(100% - 200px) ", "calc(100% - 200px)"]}
          bg="white"
          borderRadius={"25px"}
        >
          <Flex>
            <Grid gutter="lg" w={"100%"}>
              <Grid.Col order={2} key="1" xs={12} sm={12} md={8} lg={8} xl={8}>
                <Box bg="white" w="100%" borderRadius="20px">
                  <ShowOffer
                    imageFile={imageFile}
                    nomOffre={nomOffre}
                    contrat={contrat}
                    duration={duration}
                    experience={experience}
                    nomEntreprise={nomEntreprise}
                    adresseEntreprise={adresseEntreprise}
                    dateDebut={
                      moment(dateDebut).locale("fr").format("LLLL") ==
                      "Invalid date"
                        ? dateDebut
                        : moment(dateDebut).locale("fr").format("MMMM YYYY")
                    }
                    month={
                      moment(dateDebut).locale("fr").format("LLLL") ==
                      "Invalid date"
                        ? dateDebut
                        : moment(dateDebut).locale("fr").format("MM")
                    }
                    resume={resume}
                    showMissionsLabel={showMissionsLabel}
                    missions={missions}
                    url={url}
                  />
                </Box>
              </Grid.Col>
              <Grid.Col
                order={1}
                orderLg={2}
                key="2"
                xs={12}
                sm={12}
                md={4}
                lg={4}
                xl={4}
              >
                <Box
                  ms={["0px", "0px", "0px", "0px"]}
                  bg="#d4eeff"
                  w="100%"
                  height={["", "", "740px", "740px"]}
                  p={4}
                  borderRadius="20px"
                >
                  <Flex>
                    <Text
                      fontFamily={"Sofia Pro"}
                      fontSize={"24px"}
                      fontWeight={"bold"}
                    >
                      {"Modifiez ici"}
                    </Text>
                    <Spacer></Spacer>
                    <Box align={"center"} my={1} pr={4}>
                      <UploadImage getImageFile={getImageFile}></UploadImage>
                    </Box>
                  </Flex>

                  <FormControl isInvalid={eNomOffre}>
                    <Input
                      mt={"10px"}
                      placeholder="Nom de l'offre"
                      bg="white"
                      id="Nom de l'offre"
                      borderRadius="20px"
                      fontFamily={"Sofia Pro"}
                      fontSize={"14px"}
                      value={nomOffre}
                      onChange={(e) => setNomOffre(e.target.value)}
                      errorBorderColor="red.300"
                    />

                    {!eNomOffre ? "" : ""}
                  </FormControl>

                  <SimpleGrid mt={"4px"} columns={2} py={1}>
                    <FormControl isInvalid={eContrat}>
                      <Select
                        radius="20px"
                        placeholder="Contrat"
                        searchable
                        fontFamily={"Sofia Pro"}
                        onSearchChange={setContrat}
                        searchValue={contrat}
                        nothingFound="No options"
                        data={contrat_type}
                      />
                      {!eContrat ? "" : ""}
                    </FormControl>

                    <FormControl isInvalid={eSecteur}>
                      <Select
                        radius="20px"
                        placeholder="Secteur"
                        searchable
                        fontFamily={"Sofia Pro"}
                        onSearchChange={setSecteur}
                        searchValue={secteur}
                        nothingFound="No options"
                        data={work_domaine}
                      />
                      {!eSecteur ? "" : ""}
                    </FormControl>
                  </SimpleGrid>

                  <FormControl isInvalid={eNomEntreprise} my={1}>
                    <Input
                      my={"4px"}
                      placeholder="Nom de l'entreprise"
                      bg="white"
                      fontFamily={"Sofia Pro"}
                      fontSize={"14px"}
                      borderRadius="20px"
                      value={nomEntreprise}
                      errorBorderColor="red.300"
                      onChange={(e) => setNomEntreprise(e.target.value)}
                    />
                    {!eNomEntreprise ? "" : ""}
                  </FormControl>

                  <FormControl isInvalid={eAdress} my={1}>
                    <SearchLocationInput
                      getAddress={getAddress}
                      getCoords={getCoords}
                      typeAnnonce="offre"
                      adr={adresseEntreprise}
                    ></SearchLocationInput>
                    {!eAdress ? "" : ""}
                  </FormControl>

                  <FormControl isInvalid={eDateDebut} my={1}>
                    <Input
                      mt={"4px"}
                      bg={"white"}
                      borderRadius="20px"
                      fontSize={"14px"}
                      fontFamily={"Sofia Pro"}
                      placeholder="Select Date and Time"
                      size="md"
                      type="date"
                      selected={startDate}
                      onChange={(e) => {
                        setDateDebut(e.target.value.toString());
                        setStartDate(new Date(e.target.value));
                      }}
                    />{" "}
                    {!eDateDebut ? "" : ""}
                  </FormControl>

                  <FormControl isInvalid={eDuration} my={1}>
                    <Input
                      mt={"4px"}
                      placeholder="Durée du poste"
                      bg="white"
                      fontFamily={"Sofia Pro"}
                      fontSize={"14px"}
                      borderRadius="20px"
                      errorBorderColor="red.300"
                      value={duration}
                      onChange={(e) => setDuration(e.target.value)}
                    />
                    {!eDuration ? "" : ""}
                  </FormControl>

                  <FormControl isInvalid={eResume} my={1}>
                    <Textarea
                      resize="None"
                      mt={"4px"}
                      placeholder="Ajoutez une description de l’offre"
                      bg="white"
                      fontFamily={"Sofia Pro"}
                      fontSize={"14px"}
                      borderRadius="20px"
                      errorBorderColor="red.300"
                      value={resume}
                      onChange={(e) => setResume(e.target.value)}
                    />
                    {!eResume ? "" : ""}
                  </FormControl>

                  <FormControl isInvalid={eMissions} my={1}>
                    <Textarea
                      resize="None"
                      mt={"4px"}
                      placeholder="Ajoutez les missions principales du poste"
                      bg="white"
                      fontFamily={"Sofia Pro"}
                      fontSize={"14px"}
                      borderRadius="20px"
                      errorBorderColor="red.300"
                      value={missions}
                      onChange={(e) => setMissions(e.target.value)}
                    />
                    {!eMissions ? "" : ""}
                  </FormControl>

                  <FormControl isInvalid={eExperience}>
                    <Textarea
                      resize="None"
                      mt={"4px"}
                      placeholder="Experience"
                      bg="white"
                      fontFamily={"Sofia Pro"}
                      fontSize={"14px"}
                      borderRadius="20px"
                      value={experience}
                      errorBorderColor="red.300"
                      my={1}
                      onChange={(e) => setExperience(e.target.value)}
                    />
                    {!eExperience ? "" : ""}
                  </FormControl>

                  <Box my={1}>
                    <SimpleGrid
                      columns={2}
                      spacing="40px"
                      py={1}
                      mt={["40px", "40px", "", ""]}
                      position={["", "", "absolute", "absolute"]}
                      bottom={["", "", "110px", "110px"]}
                    >
                      <Button
                        py={4}
                        bg="#F1404B"
                        borderRadius="20px"
                        fontFamily={"Sofia Pro"}
                        fontSize={"14px"}
                        color={"white"}
                        errorBorderColor="red.300"
                        onClick={handleSubmit}
                      >
                        Valider
                      </Button>
                      <Button
                        bg="#f1404b"
                        color={"white"}
                        paddingInline={"40px"}
                        fontFamily={"Sofia Pro"}
                        fontSize={"14px"}
                        borderRadius="20px"
                        errorBorderColor="red.300"
                        onClick={handleClosure}
                      >
                        Offre Pourvu
                      </Button>
                    </SimpleGrid>
                  </Box>
                </Box>
              </Grid.Col>
            </Grid>
          </Flex>
        </Box>
      </Box>
    </Box>
  );
};

export default EditerOffres;
